export default function (range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.3.3@d3-interpolate/src/discrete.js
// module id = 464
// module chunks = 0